import React from 'react';

export default function Logo() {
  return (
    <p
      style={{
        display: 'block',
        height: 'auto'
      }}>🚀 GatsbyWPGutenberg Docs</p>
  );
}
